<!-- start banner Area -->
<section class="top-banner">
    <div class="top-banner-img" style="">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h1 style="">Dépôt de CV</h1>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End banner Area -->

<!-- Informations personnelles -->
<section class="container">
    <div class="row mb-5 mt-5">
        <div class="col-md-9 ">
            <div class="card pr-5 pl-5"
                style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);">
                <div class="card-body" id="depot-cv">

                    <!-- personnal info -->

                    <div class="inscription">
                        <div style="margin-top: -5px; margin-bottom: 10px;">
                            Les champs avec <strong style="color: red">**</strong> sont obligatoires.
                        </div>
                    </div>

                    <form [formGroup]="personalInfoForm" (ngSubmit)="onSubmitPersonalInfoForm()">
                        <div class="infos">
                            <h3 class="mt-3 mb-4" style="text-align: center; font-weight: bold;">Détails personnels
                            </h3>
                            <div class="row">
                                <div class="mb-3 col-md-6">
                                    <label for="training">Nom <span class="star-style">**</span></label>
                                    <input type="text" class="form-control" id="lastName" formControlName="lastName"
                                        placeholder="Nom**">
                                </div>
                                <div class="mb-3 col-md-6">
                                    <label for="training">Prénom(s) <span class="star-style">**</span></label>
                                    <input type="text" class="form-control" id="firstName" formControlName="firstName"
                                        placeholder="Prénom**">
                                </div>
                                <div class="mb-3 col-md-6">
                                    <label for="training">Email <span class="star-style">**</span></label>
                                    <input type="email" class="form-control" id="email" formControlName="email"
                                        placeholder="Email**">
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="gender">Sexe <span class="star-style">**</span></label>
                                    <select class="form-control" id="gender" formControlName="gender">
                                        <option value="Homme">Homme</option>
                                        <option value="Femme">Femme</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="maritalStatus">Situation matrimoniale</label>
                                    <select class="form-control" id="maritalStatus" formControlName="marital_status">
                                        <option value="célibataire">Célibataire</option>
                                        <option value="Marié(e) avec enfant">Marié(e) avec enfants</option>
                                        <option value="Marié(e) sans enfant">Marié(e) sans enfants</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="dateBirth">Date de naissance <span class="star-style">**</span></label>
                                    <input type="date" class="form-control h-40px" id="dateBirth"
                                        formControlName="dateBirth">
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="country">Pays</label>
                                    <select class="form-control" id="country" formControlName="country"
                                        (ngModelChange)="onChangeCountry($event)">
                                        <option [value]="country" *ngFor="let country of countryList">{{ country
                                            }}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="city">Ville</label>
                                    <select class="form-control" id="city" formControlName="city">
                                        <option [value]="city" *ngFor="let city of cityList">{{ city }}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="phone1">Téléphone<span class="star-style">**</span></label>
                                    <input type="text" class="form-control h-40px" id="phone1" formControlName="phone1">
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="tempWorker">Emploi recherché: <span class="star-style"></span></label>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="Emploi"
                                            id="flexCheckDefault" (change)="onCheckboxProfilChange($event)">
                                        <label class="form-check-label" for="flexCheckDefault">
                                            Emploi
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="Intérim"
                                            id="flexCheckChecked" (change)="onCheckboxProfilChange($event)">
                                        <label class="form-check-label" for="flexCheckChecked">
                                            Intérim
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                    <!-- trainings -->
                    <form [formGroup]="trainingsForm" (ngSubmit)="onSubmitTrainingForm()">
                        <h3 class="mt-5 mb-3" style="text-align: center; font-weight: bold;">Détails académiques
                        </h3>
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label for="domaine">Domaine <span class="star-style">**</span></label>
                                <select class="form-control h-40px" id="" formControlName="training_id">
                                    <option value="" selected>Selectionner...</option>
                                    <option [value]="training.getId()" *ngFor="let training of trainingList">{{
                                        training.getLibelle() }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="level_of_study">Niveau d'études <span class="star-style">**</span></label>
                                <select class="form-control" id="" formControlName="level_of_study">
                                    <option value="">Selectionner...</option>
                                    <option value="Secondaire">Secondaire</option>
                                    <option value="Terminal">Terminal</option>
                                    <option value="Formation professionnelle">Formation professionnelle</option>
                                    <option value="Baccalauréat">Baccalauréat</option>
                                    <option value="Universitaire sans diplôme">Universitaire sans diplôme
                                    </option>
                                    <option value="BAC + 2">BAC + 2</option>
                                    <option value="Licence(BAC + 3)">Licence(BAC + 3)</option>
                                    <option value="Master 1(BAC + 4)">Master 1(BAC + 4)</option>
                                    <option value="Master 2(BAC + 5)">Master 2(BAC + 5)</option>
                                    <option value="Doctorat(BAC + 7)">Doctorat(BAC + 7)</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="university">Université <span class="star-style">**</span></label>
                                <input type="text" class="form-control h-40px text-uppercase" id="university"
                                    formControlName="university">
                            </div>

                        </div>
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label for="periodStartTraining">Date début <span class="star-style">**</span></label>
                                <select class="form-control" id="periodStartTraining" formControlName="month_start">
                                    <option value="">Selectionner...</option>
                                    <option value="01">Janvier</option>
                                    <option value="02">Février</option>
                                    <option value="03">Mars</option>
                                    <option value="04">Avril</option>
                                    <option value="05">Mai</option>
                                    <option value="06">Juin</option>
                                    <option value="07">Juillet</option>
                                    <option value="08">Aôut</option>
                                    <option value="09">Septembre</option>
                                    <option value="10">Octobre</option>
                                    <option value="11">Novembre</option>
                                    <option value="12">Décembre</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="periodStartTraining">Année <span class="star-style">**</span></label>
                                <!-- <input type="number" step="1" min="1900" class="form-control h-40px" > -->
                                <select class="form-control" id="" formControlName="year_start">

                                    <option value="1984">1984</option>
                                    <option value="1985">1985</option>
                                    <option value="1986">1986</option>
                                    <option value="1987">1987</option>
                                    <option value="1988">1988</option>
                                    <option value="1989">1989</option>
                                    <option value="1990">1990</option>
                                    <option value="1991">1991</option>
                                    <option value="1992">1992</option>
                                    <option value="1993">1993</option>
                                    <option value="1994">1994</option>
                                    <option value="1995">1995</option>
                                    <option value="1996">1996</option>
                                    <option value="1997">1997</option>
                                    <option value="1998">1998</option>
                                    <option value="1999">1999</option>
                                    <option value="2000">2000</option>
                                    <option value="2001">2001</option>
                                    <option value="2002">2002</option>
                                    <option value="2003">2003</option>
                                    <option value="2004">2004</option>
                                    <option value="2005">2005</option>
                                    <option value="2006">2006</option>
                                    <option value="2007">2007</option>
                                    <option value="2008">2008</option>
                                    <option value="2009">2009</option>
                                    <option value="2010">2010</option>
                                    <option value="2011">2011</option>
                                    <option value="2012">2012</option>
                                    <option value="2013">2013</option>
                                    <option value="2014">2014</option>
                                    <option value="2015">2015</option>
                                    <option value="2016">2016</option>
                                    <option value="2017">2017</option>
                                    <option value="2018">2018</option>
                                    <option value="2019">2019</option>
                                    <option value="2020">2020</option>
                                    <option value="2021">2021</option>
                                    <option value="2022">2022</option>
                                    <option value="2023">2023</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4 my-auto">
                                <input type="checkbox" id="trainingInProgress"
                                    (click)="functionsService.showOrHideEndDate('blockPeriodEndTraining', 'trainingInProgress', true)">
                                <label for="trainingInProgress" style="margin-left: 5px"
                                    (click)="functionsService.showOrHideEndDate('blockPeriodEndTraining', 'trainingInProgress', false)">En
                                    cours</label>
                            </div>
                        </div>
                        <div class="row" id="blockPeriodEndTraining">
                            <div class="form-group col-md-4" id="blockPeriodEndTraining">
                                <label for="periodEndTraining">Date Fin</label>
                                <select class="form-control" id="periodEndTraining" formControlName="month_end">
                                    <option value="">Selectionner...</option>
                                    <option value="01">Janvier</option>
                                    <option value="02">Février</option>
                                    <option value="03">Mars</option>
                                    <option value="04">Avril</option>
                                    <option value="05">Mai</option>
                                    <option value="06">Juin</option>
                                    <option value="07">Juillet</option>
                                    <option value="08">Aôut</option>
                                    <option value="09">Septembre</option>
                                    <option value="10">Octobre</option>
                                    <option value="11">Novembre</option>
                                    <option value="12">Décembre</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="periodEndTraining">Année</label>
                                <!-- <input type="number" step="1" min="1900" id="periodEndTraining"
                                                                class="form-control h-40px" formControlName="year_end"> -->
                                <select class="form-control" id="year" formControlName="year_end">
                                    <option value="1984">1984</option>
                                    <option value="1985">1985</option>
                                    <option value="1986">1986</option>
                                    <option value="1987">1987</option>
                                    <option value="1988">1988</option>
                                    <option value="1989">1989</option>
                                    <option value="1990">1990</option>
                                    <option value="1991">1991</option>
                                    <option value="1992">1992</option>
                                    <option value="1993">1993</option>
                                    <option value="1994">1994</option>
                                    <option value="1995">1995</option>
                                    <option value="1996">1996</option>
                                    <option value="1997">1997</option>
                                    <option value="1998">1998</option>
                                    <option value="1999">1999</option>
                                    <option value="2000">2000</option>
                                    <option value="2001">2001</option>
                                    <option value="2002">2002</option>
                                    <option value="2003">2003</option>
                                    <option value="2004">2004</option>
                                    <option value="2005">2005</option>
                                    <option value="2006">2006</option>
                                    <option value="2007">2007</option>
                                    <option value="2008">2008</option>
                                    <option value="2009">2009</option>
                                    <option value="2010">2010</option>
                                    <option value="2011">2011</option>
                                    <option value="2012">2012</option>
                                    <option value="2013">2013</option>
                                    <option value="2014">2014</option>
                                    <option value="2015">2015</option>
                                    <option value="2016">2016</option>
                                    <option value="2017">2017</option>
                                    <option value="2018">2018</option>
                                    <option value="2019">2019</option>
                                    <option value="2020">2020</option>
                                    <option value="2021">2021</option>
                                    <option value="2022">2022</option>
                                    <option value="2023">2023</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-4">
                                <label for="diploma">Attestation <span style="font-size: 10px; font-weight: 700;">(pdf,
                                        < 1Mo)</span>
                                </label>
                                <span class="form-control h-40px btn btn-success" (click)="chooseDiploma()">Joindre
                                    fichier</span><span *ngIf="diplomaFile != null"
                                    style="font-size: 10px; font-weight: 700; color: green">
                                    Super! Fichier
                                    joint</span>
                            </div>
                            <div class="col-md-4">
                                <button type="submit" style="margin-top: 35px;" class="primary-btn text-white"
                                    [disabled]="trainingsForm.invalid" *ngIf="!trainingIsLoading">Ajouter</button>
                                <p class="text-danger" style="padding-top: 15px; margin-left: 15px;"
                                    *ngIf="trainingIsLoading">Veuillez
                                    patienter...
                                </p>
                            </div>
                        </div>
                    </form>
                    <div class="form-group mt-5" style="width: 100%; overflow: auto;">
                        <table class="table table-bordered">
                            <tr>
                                <th>Formation</th>
                                <th>Université</th>
                                <th>Periode</th>
                                <th>Niveau d'étude</th>
                                <!-- <th>Diplôme</th> -->
                                <th>Action</th>
                            </tr>
                            <tr *ngFor="let candidateTraining of candidateTrainingList">
                                <td>{{ candidateTraining.getTrainings()['libelle'] }}</td>
                                <td>{{ candidateTraining.getUniversity() }}</td>
                                <td>{{ candidateTraining.getPeriodStart() }} à <span
                                        *ngIf="candidateTraining.getInProgress()">ce
                                        jour</span><span *ngIf="!candidateTraining.getInProgress()">{{
                                        candidateTraining.getPeriodEnd()
                                        }}</span></td>
                                <td>{{ candidateTraining.getLevelOfStudy() }}</td>
                                <!-- <td><a *ngIf="candidateTraining.getDiplomaPath() != ''"
                                                                [href]="candidateTraining.getDiplomaPath()" target="_blank"
                                                                class="btn btn-success">Voir</a></td>-->
                                <td>

                                    <span class="btn btn-info a-btn-slide-text mr-1">
                                        <span class="glyphicon glyphicon-edit" aria-hidden="true">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                fill="currentColor" class="bi bi-pen" viewBox="0 0 16 16">
                                                <path
                                                    d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z" />
                                            </svg>
                                        </span>
                                    </span>

                                    <a *ngIf="candidateTraining.getDiplomaPath() != ''"
                                        [href]="candidateTraining.getDiplomaPath()" target="_blank"
                                        class="btn btn-primary a-btn-slide-text mr-1"><svg
                                            xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                                            <path
                                                d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                            <path
                                                d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                        </svg></a>
                                    <span class="btn btn-danger a-btn-slide-text"
                                        (click)="removeTraining(candidateTraining.getId())">
                                        <span class="glyphicon glyphicon-remove" aria-hidden="true"><svg
                                                xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                <path
                                                    d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                                <path fill-rule="evenodd"
                                                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                            </svg></span>
                                    </span>

                                </td>
                            </tr>
                        </table>
                    </div>

                    <!-- certifications -->

                    <form [formGroup]="certificatsForm" (ngSubmit)="onSubmitCertificatForm()">
                        <h3 class="mt-5" style="text-align: center; font-weight: bold;">Certifications</h3>
                        <div class="row">
                            <div class="form-group col-md-12">
                                <label for="certificat_libelle">Titre du certificat <span
                                        class="star-style">**</span></label>
                                <input type="text" id="certificat_libelle" class="form-control text-uppercase"
                                    formControlName="libelle">
                            </div>
                            <div class="form-group col-md-6">
                                <label for="certificat">Certificat<span style="font-size: 10px; font-weight: 700;">(pdf,
                                        < 1Mo)</span>
                                </label>
                                <span class="form-control h-40px btn btn-success" (click)="chooseCertificat()">Joindre
                                    fichier</span><span *ngIf="certificatFile != null"
                                    style="font-size: 10px; font-weight: 700; color: green">
                                    Super! Fichier
                                    joint</span>
                            </div>
                            <div class="col-md-6">
                                <button type="submit" style="margin-top: 35px;" class="primary-btn text-white"
                                    [disabled]="certificatsForm.invalid" *ngIf="!certificatIsLoading">Ajouter</button>
                                <p class="text-danger" style="padding-top: 15px; margin-left: 15px;"
                                    *ngIf="certificatIsLoading">Veuillez
                                    patienter...
                                </p>
                            </div>
                        </div>

                    </form>
                    <div class="form-group" style="width: 100%; overflow: auto;">
                        <table class="table table-bordered">
                            <tr>
                                <th>Titre du certificat</th>
                                <th>Certificat</th>
                                <th>Action</th>
                            </tr>
                            <tr *ngFor="let candidateCertificate of candidateCertificateList">
                                <td>{{ candidateCertificate['libelle'] }}</td>
                                <td><a *ngIf="candidateCertificate.getFilePath() != ''"
                                        [href]="candidateCertificate.getFilePath()" target="_blank"
                                        class="btn btn-info">Voir</a></td>
                                <td><span class="btn btn-danger"
                                        (click)="removeCertificat(candidateCertificate.getId())">Supp</span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <!-- professionnelles -->
                    <form id="" [formGroup]="experiencesForm" (ngSubmit)="onSubmitExperienceForm()">
                        <h3 class="mt-5" style="text-align: center; font-weight: bold;">Cursus professionnels
                        </h3>

                        <div class="row ">
                            <div class="form-group col-md-6">
                                <label for="company">Nom de l'entreprise <span class="star-style">**</span></label>
                                <input type="text" class="form-control h-40px text-uppercase" id="company"
                                    formControlName="company">
                            </div>
                            <div class="form-group col-md-6">
                                <label for="area_activity">Secteur d'activité <span class="star-style">**</span></label>
                                <select class="form-control" id="area_activity" formControlName="area_activity_id">
                                    <option value="" selected>Selectionner...</option>
                                    <option [value]="areaActivity.getId()"
                                        *ngFor="let areaActivity of areaActivityList">{{
                                        areaActivity.getLibelle() }}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="profession">Profession <span class="star-style">**</span></label>
                                <select class="form-control" id="profession" formControlName="profession_id">
                                    <option value="">Selectionner...</option>
                                    <option value="{{ profession.getId() }}" *ngFor="let profession of professionList">
                                        {{
                                        profession.getLibelle() }}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="job_title">Titre du poste <span class="star-style">**</span></label>
                                <input type="text" class="form-control h-40px text-uppercase" id="job_title"
                                    formControlName="job_title">
                            </div>

                            <div class="form-group col-md-6">
                                <label for="positionLevel">Type de contrat <span class="star-style">**</span></label>
                                <select class="form-control" id="positionLevel" formControlName="position_level">
                                    <option value="">Selectionner...</option>
                                    <option value="Stage">Stage</option>
                                    <option value="CDD">CDD</option>
                                    <option value="CDI">CDI</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="periodStartJob">Date début/Mois <span class="star-style">**</span></label>
                                <select class="form-control" id="periodStartJob" formControlName="month_start">
                                    <option value="">Selectionner...</option>
                                    <option value="01">Janvier</option>
                                    <option value="02">Février</option>
                                    <option value="03">Mars</option>
                                    <option value="04">Avril</option>
                                    <option value="05">Mai</option>
                                    <option value="06">Juin</option>
                                    <option value="07">Juillet</option>
                                    <option value="08">Aôut</option>
                                    <option value="09">Septembre</option>
                                    <option value="10">Octobre</option>
                                    <option value="11">Novembre</option>
                                    <option value="12">Décembre</option>
                                </select>

                                <!-- <input type="number" step="1" min="1900" class="form-control h-40px"
                                                                        style="width: 40%;" formControlName="year_start"> -->
                            </div>
                            <div class="form-group col-md-4">
                                <label for="periodStartJob">Date début/Année <span class="star-style">**</span></label>
                                <select class="form-control" id="year" formControlName="year_start">
                                    <option value="1984">1984</option>
                                    <option value="1985">1985</option>
                                    <option value="1986">1986</option>
                                    <option value="1987">1987</option>
                                    <option value="1988">1988</option>
                                    <option value="1989">1989</option>
                                    <option value="1990">1990</option>
                                    <option value="1991">1991</option>
                                    <option value="1992">1992</option>
                                    <option value="1993">1993</option>
                                    <option value="1994">1994</option>
                                    <option value="1995">1995</option>
                                    <option value="1996">1996</option>
                                    <option value="1997">1997</option>
                                    <option value="1998">1998</option>
                                    <option value="1999">1999</option>
                                    <option value="2000">2000</option>
                                    <option value="2001">2001</option>
                                    <option value="2002">2002</option>
                                    <option value="2003">2003</option>
                                    <option value="2004">2004</option>
                                    <option value="2005">2005</option>
                                    <option value="2006">2006</option>
                                    <option value="2007">2007</option>
                                    <option value="2008">2008</option>
                                    <option value="2009">2009</option>
                                    <option value="2010">2010</option>
                                    <option value="2011">2011</option>
                                    <option value="2012">2012</option>
                                    <option value="2013">2013</option>
                                    <option value="2014">2014</option>
                                    <option value="2015">2015</option>
                                    <option value="2016">2016</option>
                                    <option value="2017">2017</option>
                                    <option value="2018">2018</option>
                                    <option value="2019">2019</option>
                                    <option value="2020">2020</option>
                                    <option value="2021">2021</option>
                                    <option value="2022">2022</option>
                                    <option value="2023">2023</option>
                                </select>
                            </div>

                            <div class="form-group col-md-4 my-auto">
                                <input type="checkbox" id="experienceInProgress"
                                    (click)="functionsService.showOrHideEndDate('experienceDateFin', 'experienceInProgress', true)"
                                    checked>
                                <label for="experienceInProgress" style="margin-left: 5px"
                                    (click)="functionsService.showOrHideEndDate('experienceDateFin', 'experienceInProgress', false)">En
                                    cours</label>
                            </div>
                        </div>
                        <div id="experienceDateFin" style="display: none">
                            <div class="row">
                                <div class="form-group col-md-4">
                                    <label for="periodEndJob">Date Fin/Mois</label>
                                    <select class="form-control" id="periodEndJob" formControlName="month_end">
                                        <option value="">Selectionner...</option>
                                        <option value="01">Janvier</option>
                                        <option value="02">Février</option>
                                        <option value="03">Mars</option>
                                        <option value="04">Avril</option>
                                        <option value="05">Mai</option>
                                        <option value="06">Juin</option>
                                        <option value="07">Juillet</option>
                                        <option value="08">Aôut</option>
                                        <option value="09">Septembre</option>
                                        <option value="10">Octobre</option>
                                        <option value="11">Novembre</option>
                                        <option value="12">Décembre</option>
                                    </select>

                                </div>
                                <div class="form-group col-md-4">
                                    <label for="periodStartJob">Date début/Année <span
                                            class="star-style"></span></label>
                                    <select class="form-control" id="year" formControlName="year_end">
                                        <option value="1984">1984</option>
                                        <option value="1985">1985</option>
                                        <option value="1986">1986</option>
                                        <option value="1987">1987</option>
                                        <option value="1988">1988</option>
                                        <option value="1989">1989</option>
                                        <option value="1990">1990</option>
                                        <option value="1991">1991</option>
                                        <option value="1992">1992</option>
                                        <option value="1993">1993</option>
                                        <option value="1994">1994</option>
                                        <option value="1995">1995</option>
                                        <option value="1996">1996</option>
                                        <option value="1997">1997</option>
                                        <option value="1998">1998</option>
                                        <option value="1999">1999</option>
                                        <option value="2000">2000</option>
                                        <option value="2001">2001</option>
                                        <option value="2002">2002</option>
                                        <option value="2003">2003</option>
                                        <option value="2004">2004</option>
                                        <option value="2005">2005</option>
                                        <option value="2006">2006</option>
                                        <option value="2007">2007</option>
                                        <option value="2008">2008</option>
                                        <option value="2009">2009</option>
                                        <option value="2010">2010</option>
                                        <option value="2011">2011</option>
                                        <option value="2012">2012</option>
                                        <option value="2013">2013</option>
                                        <option value="2014">2014</option>
                                        <option value="2015">2015</option>
                                        <option value="2016">2016</option>
                                        <option value="2017">2017</option>
                                        <option value="2018">2018</option>
                                        <option value="2019">2019</option>
                                        <option value="2020">2020</option>
                                        <option value="2021">2021</option>
                                        <option value="2022">2022</option>
                                        <option value="2023">2023</option>
                                    </select>
                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="form-group col-lg-6">
                                <label for="certificate">Certificat de travail<span
                                        style="font-size: 10px; font-weight: 700;">(pdf, < 1Mo)</span>
                                </label>
                                <span class="form-control h-40px btn btn-success"
                                    (click)="chooseAttestation()">Fichier</span><span *ngIf="attestationFile != null"
                                    style="font-size: 10px; font-weight: 700; color: green"> Super!
                                    Fichier joint</span>
                            </div>
                            <div class="col-lg-6">
                                <button type="submit" style="margin-top: 35px;" class="primary-btn text-white"
                                    [disabled]="experiencesForm.invalid" *ngIf="!experienceIsLoading">Ajouter</button>
                                <p class="text-danger" style="padding-top: 15px; margin-left: 15px;"
                                    *ngIf="experienceIsLoading">
                                    Veuillez
                                    patienter...
                                </p>
                            </div>
                        </div>

                    </form>
                    <div class="form-group" style="width: 100%; overflow: auto;">
                        <table class="table table-bordered">
                            <tr>
                                <th>Titre du poste</th>
                                <th width="100">Société</th>
                                <th style="width: 250px !important;">Niveau de poste</th>
                                <th>Période</th>
                                <!-- <th>Manag. equipe</th>
                                <th>Titre sup. N + 1</th>
                                <th>Motif de départ</th> -->
                                <th>Action</th>
                            </tr>
                            <tr *ngFor="let experience of experienceList">
                                <td>{{ experience.getJobTitle() }}</td>
                                <td>
                                    <div> {{ experience.getCompany() }}</div>
                                </td>
                                <td>{{ experience.getPositionLevel() }}</td>
                                <td>{{ experience.getPeriodStart() }} à <span *ngIf="experience.getInProgress()">ce
                                        jour</span><span *ngIf="!experience.getInProgress()">{{
                                        experience.getPeriodEnd() }}</span>
                                </td>
                                <!-- <td>{{ experience.getTeamManagement() }}</td>
                                <td>{{ experience.getSupervisorTitle() }}</td>
                                <td>{{ experience.getReasonForLeaving() }}</td> -->

                                <td>
                                    <div style="display: flex;">
                                        <span class="btn btn-info a-btn-slide-text mr-1">
                                            <span class="glyphicon glyphicon-edit" aria-hidden="true">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor" class="bi bi-pen" viewBox="0 0 16 16">
                                                    <path
                                                        d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z" />
                                                </svg>
                                            </span>
                                        </span>
                                        <a *ngIf="experience.getCertificatePath() != ''"
                                            [href]="experience.getCertificatePath()" target="_blank"
                                            class="btn btn-primary a-btn-slide-text mr-1"><svg
                                                xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                                                <path
                                                    d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                                <path
                                                    d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                            </svg>
                                        </a>
                                        <span class="btn btn-danger a-btn-slide-text"
                                            (click)="removeExperience(experience.getId())">
                                            <span class="glyphicon glyphicon-remove" aria-hidden="true"><svg
                                                    xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                    <path
                                                        d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                                    <path fill-rule="evenodd"
                                                        d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                                </svg></span>
                                        </span>
                                    </div>

                                </td>
                            </tr>
                        </table>
                    </div>

                    <!-- competences -->
                    <form [formGroup]="skillsForm" (ngSubmit)="onSubmitSkillForm()">
                        <h3 class="mt-5" style="text-align: center; font-weight: bold;">Compétences clés</h3>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label for="skill">Logiciels MSOFFICE <span class="star-style">**</span></label>
                                    <select class="form-control" id="skill" formControlName="skill_id">
                                        <option value="">Selectionner...</option>
                                        <option [value]="skill.getId()" *ngFor="let skill of skillList">{{
                                            skill.getLibelle() }}
                                        </option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="skillLevel">Niveau de maitrise <span
                                            class="star-style">**</span></label>
                                    <select class="form-control" id="skillLevel" formControlName="level">
                                        <option value="">Selectionner...</option>
                                        <option value="Débutant">Débutant</option>
                                        <option value="Intermédiaire">Intermédiaire</option>
                                        <option value="Excellente maitrise">Excellente maitrise</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <button type="submit" class="primary-btn text-white" [disabled]="skillsForm.invalid"
                                        *ngIf="!skillIsLoading">Ajouter</button>
                                    <p class="text-danger" style="padding-top: 15px; margin-left: 15px;"
                                        *ngIf="skillIsLoading">Veuillez
                                        patienter...
                                    </p>
                                </div>

                            </div>

                        </div>
                    </form>
                    <div class="form-group " style="width: 100%; overflow: auto;">
                        <table class="table table-bordered">
                            <tr>
                                <th>Compétence</th>
                                <th>Niveau de maitrise</th>
                                <th>Action</th>
                            </tr>
                            <tr *ngFor="let candidateSkill of candidateSkillList">
                                <td>{{ candidateSkill.getSkills()['libelle'] }}</td>
                                <td>{{ candidateSkill.getLevel() }}</td>
                                <td><span class="btn btn-danger"
                                        (click)="removeSkill(candidateSkill.getId())">Supp</span></td>
                            </tr>
                        </table>
                    </div>

                    <!-- langues -->
                    <form [formGroup]="languagesForm" (ngSubmit)="onSubmitLanguageForm()">
                        <h3 class="mt-5" style="text-align: center; font-weight: bold;">Langues </h3>
                        <div class="row">
                            <div class="form-group col-lg-6">
                                <label for="language">Langues <span class="star-style">**</span></label>
                                <select class="form-control" id="language" formControlName="language_id">
                                    <option value="">Selectionner...</option>
                                    <option [value]="language.getId()" *ngFor="let language of languageList">{{
                                        language.getLibelle() }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group col-lg-6">
                                <label for="levelLanguage">Niveau de maitrise <span class="star-style">**</span></label>
                                <select class="form-control" id="levelLanguage" formControlName="level">
                                    <option value="">Selectionner...</option>
                                    <option value="Débutant">Débutant</option>
                                    <option value="Intermédiaire">Intermédiaire</option>
                                    <option value="Excellente maitrise">Excellente maitrise</option>
                                </select>
                            </div>
                            <div class="form-group col-lg-6">
                                <button type="submit" class="primary-btn text-white">Ajouter</button>
                                <p class="text-danger" style="padding-top: 15px; margin-left: 15px;"
                                    *ngIf="languageIsLoading">Veuillez
                                    patienter...
                                </p>
                            </div>
                        </div>
                    </form>
                    <div class="form-group mt-5" style="width: 100%; overflow: auto;">
                        <table class="table table-bordered">
                            <tr>
                                <th>Langue</th>
                                <th>Niveau de maitrise</th>
                                <th>Action</th>
                            </tr>
                            <tr *ngFor="let candidateLanguage of candidateLanguageList">
                                <td>{{ candidateLanguage.getLanguages()['libelle'] }}</td>
                                <td>{{ candidateLanguage.getLevel() }}</td>
                                <td><span class="btn btn-danger"
                                        (click)="removeLanguage(candidateLanguage.getId())">Supp</span>
                                </td>
                            </tr>
                        </table>
                    </div>


                    <div class="cv">
                        <h3 class="mt-5" style="text-align: center; font-weight: bold;">CV </h3>
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label for="curriculumVitae">Curriculum vitae <span
                                        style="font-size: 10px; font-weight: 700;">(pdf,
                                        < 1Mo)</span> <span class="star-style">**</span></label>
                                <span class="btn btn-primary w-100" (click)="chooseNewCV()">Remplacer
                                    CV</span>

                                <span *ngIf="cvFile != null" style="font-size: 10px; font-weight: 700; color: green">
                                    Super!
                                    Fichier
                                    joint</span>
                            </div>

                        </div>
                    </div>
                    <!-- Div block afficher/reduire -->
                    <button type="submit" class=" btn btn-submit text-white"
                        (click)="onSubmitPersonalInfoForm()">SAUVEGARDER</button>
                    <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="isLoading">
                        Veuillez patienter...</p>

                </div>
            </div>
        </div>
        <div class="col-md-3">
            <app-articles></app-articles>
        </div>

    </div>
</section>
<section
    style="background:url(assets/img/back-produits.svg); background-size: cover; background-position: center; background-repeat: no-repeat;">
    <div class="container">
        <div class="row justify-content-center">
            <div class=" col-lg-10 mb-5">
                <h2 class="mt-5"
                    style="color: #00027D;     font-size: 35px !important;font-weight: bold; text-align: center;">
                    Trouvez votre prochain emplois.</h2>
                <p class="" style="text-align: center;">Votre prochain poste pourrait être au sein de
                    l'une de ces entreprises leaders. Cliquez sur le logo de l'entreprise pour
                    voir les postes annoncés</p>
                <div class="row justify-content-center">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card"
                                style=" box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="  col-6 col-lg-2 col-sm-4">
                                            <div class=""><a href="https://fr.jobsora.co" target="_blank"><img
                                                        src="assets/img/partenaire2.png"
                                                        style="height: 70px; width: 136.667px; object-fit: contain; "
                                                        alt="mtn logo"></a>
                                            </div>
                                        </div>
                                        <div class="  col-6 col-lg-2 col-sm-4">
                                            <div class=""> <a href="https://jooble.org" target="_blank"><img
                                                        src="assets/img/jooble.png"
                                                        style="height: 100px; width: 136.667px; object-fit: contain; "
                                                        alt="mtn logo"></a>
                                            </div>
                                        </div>
                                        <div class="  col-6 col-lg-2 col-sm-4">
                                            <div class=""><a href="https://www.cdiscussion.com" target="_blank"><img
                                                        src="assets/img/cdiscount.PNG"
                                                        style="height: 100px; width: 136.667px; object-fit: contain; "
                                                        alt="mtn logo"></a>
                                            </div>
                                        </div>
                                        <div class="  col-6 col-lg-2 col-sm-4">
                                            <div class=""><a href="http://www.parseal.com" target="_blank"><img
                                                        src="assets/img/logo/parseal_full_logo.png"
                                                        style="height: 100px; width: 136.667px; object-fit: contain; "
                                                        alt="mtn logo"></a>
                                            </div>
                                        </div>
                                        <div class="  col-6 col-lg-2 col-sm-4">
                                            <div class=""><a href="https://www.nasco.net/careers/submit-your-cv"
                                                    target="_blank"><img src="assets/img/logo/NASCO_GROUP.png"
                                                        style="height: 100px; width: 136.667px; object-fit: contain; "
                                                        alt="mtn logo"></a>
                                            </div>
                                        </div>
                                        <div class="  col-6 col-lg-2 col-sm-4">
                                            <div class=""><a href="https://jobs.unops.org" target="_blank"><img
                                                        src="assets/img/logo/UNOPS.jpg"
                                                        style="height: 100px; width: 136.667px; object-fit: contain; "
                                                        alt="mtn logo"></a>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>